import React from 'react';
import { useReactToPrint } from 'react-to-print';
import { Helmet } from 'react-helmet-async';
import { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
// @mui
import { Stack, Button, Container, Typography } from '@mui/material';
// components
import Iconify from '../components/iconify';

import { useNotification } from '../context/NotificationContext';
import { useAuth } from '../context/AuthContext';
import { fCurrency, fCurrencyNoPrefix, addNumberToZeros } from "../utils/formatNumber"

// ----------------------------------------------------------------------

const PrintContent = React.forwardRef((props, ref) => {

    window.convertir = require('numero-a-letras');

    function tieneCentavos(numero) {
        // Asegúrate de que el número es un flotante
        if (typeof numero !== 'number' || Number.isNaN(numero)) {
            return false
        }

        // Convierte el número a una cadena con un formato de decimales fijo
        const decimalString = numero.toFixed(2);

        // Divide la cadena en parte entera y decimal
        const [entero, decimal] = decimalString.split('.');

        // Verifica si la parte decimal es diferente de "00"
        return decimal !== '00';
    }

    function eliminarCentavosYMoneda(cadena, monto) {
        // Divide la cadena en partes usando el espacio como delimitador
        const partes = cadena.split(' ');

        let result
        
        if (partes.length > 2) {
            // Une todas las partes excepto los dos últimos
            result = partes.slice(0, -2).join(' ').trim();
        }

        // Si no hay suficientes partes, simplemente retorna la cadena original
        return `${result.trim()}`
    }


    const { routeParams: { valuesToEdit } } = props;
    const { currentUser } = useAuth();

    const date = `${valuesToEdit.day}/${valuesToEdit.month}/${valuesToEdit.year}`;
    const dateNumbers = `${valuesToEdit.day}${valuesToEdit.month}${valuesToEdit.year}`;

    const montoLetras = window.convertir.NumerosALetras(valuesToEdit.amount)
    const amuntDecims = ` Con ${valuesToEdit.amount.toFixed(2).split('.')[1]}/100`
    const amountLetters = eliminarCentavosYMoneda(montoLetras, valuesToEdit.amount) + amuntDecims


    return (
        <div ref={ref} style={{ paddingLeft: 0, paddingRight: 0, fontFamily: "monospace", letterSpacing: 1, fontSize: 13, transform: "scaleY(1.5)" }}>


            <div style={{ margin: 0, padding: 0, position: "absolute", top: "0.08in", right: "2.1in", textAlign: "center", fontSize: 10 }}>

                <span style={{ margin: 0, padding: 0 }} >
                    CK-{addNumberToZeros(valuesToEdit.checkbook_account.account_sequence, 6)}
                </span>

            </div>


            <div style={{ margin: 0, padding: 0, position: "absolute", top: "0.27in", left: "0.66in", textAlign: "center", fontSize: 10 }}>

                <span style={{ margin: 0, padding: 0 }} >
                    {valuesToEdit?.checkbook_account?.account_code || ""}
                </span>
                <br />
                <span style={{ margin: 0, padding: 0 }} >
                    {date}
                </span>

            </div>

            <div style={{ margin: 0, padding: 0, position: "absolute", top: "0.24in", left: "2in", width: 400, textAlign: "center", fontSize: 10 }}>

                <span style={{ margin: 0, padding: 0 }} >
                    {valuesToEdit?.output || ""}
                </span>
                <br />
                <span style={{ margin: 0, padding: 0, }} >
                    {valuesToEdit?.checkbook_comment || ""}
                </span>
                <br />
                <span style={{ margin: 0, padding: 0 }} >
                    {valuesToEdit?.checkbook_account?.account_name}
                </span>

            </div>


            <div style={{ margin: 0, padding: 0, position: "absolute", top: "0.46in", right: "0.46in", textAlign: "center", fontSize: 10 }}>

                <span style={{ margin: 0, padding: 0, letterSpacing: 1 }} >
                    {fCurrency(valuesToEdit.amount)}
                </span>

            </div>

            <div style={{ margin: 0, padding: 0, position: "absolute", top: "1.65in", right: "0.07in", letterSpacing: 10, fontSize: 13, transform: "scaleY(1.2)" }}>

                <span style={{ margin: 0, padding: 0,  }} >
                    {dateNumbers}
                </span>

            </div>

            <div style={{ margin: 0, padding: 0, position: "absolute", top: "1.97in", left: "2.46in", textAlign: "center" }}>

                <span style={{ margin: 0, padding: 0 }} >
                    {currentUser.displayName}
                </span>

            </div>

            <div style={{ margin: 0, padding: 0, position: "absolute", top: "1.98in", right: "0.7in", letterSpacing: 8, fontSize: 13, transform: "scaleY(1.2)" }}>

                <span style={{ margin: 0, padding: 0, letterSpacing: 3 }} >
                    {fCurrencyNoPrefix(valuesToEdit.amount)}
                </span>

            </div>


            <div style={{ margin: 0, padding: 0, position: "absolute", top: "2.18in", left: "0.8in", textAlign: "center" }}>

                <span style={{ margin: 0, padding: 0 }} >
                    {amountLetters}
                </span>

            </div>

        </div >
    )
});


export default function PrintWorkbookPage() {
    const navigate = useNavigate();
    const location = useLocation();
    const routeParams = location.state || {};
    const { showSnackbar } = useNotification();
    const [openModalWorkBook, setOpenModalWorkBook] = useState(false);

    const printContentRef = useRef();

    useEffect(() => {
        if (!routeParams.valuesToEdit) {
            navigate("/checkbooks");
        }
    }, [routeParams, navigate]);

    const handlePrint = useReactToPrint({
        content: () => printContentRef.current
    });

    return (
        <>
            <Helmet>
                <title>Cuentas de banco | {process.env.REACT_APP_APP_NAME} </title>
            </Helmet>

            <Container justifyContent={"center"}>
                <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                    <Typography variant="h4" gutterBottom>
                        Impresión de cheques
                    </Typography>
                    <Button variant="contained" startIcon={<Iconify icon='eva:printer-fill' />} onClick={handlePrint}>
                        Imprimir
                    </Button>
                </Stack>

                <div>
                    <PrintContent ref={printContentRef} routeParams={routeParams} />
                </div>
            </Container>
        </>
    );
}
